(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dyna-error", [], factory);
	else if(typeof exports === 'object')
		exports["dyna-error"] = factory();
	else
		root["dyna-error"] = factory();
})(global, () => {
return 